import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { classnames } from 'tailwindcss-classnames';
import React from 'react';
import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';
import RichTextA11yWrapper from 'components/helpers/RichTextA11yWrapper';
import useGoFundMe from 'lib/react/useGoFundMe';

export type GoFundMeFormProps = Sitecore.Override.ComponentBase &
  Components.Forms.GoFundMeForm.Fields.GoFundMeForm;

const GoFundMeForm = ({ fields }: GoFundMeFormProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = useExperienceEditor();
  useGoFundMe();

  // if script url is not present, then the form wouldn't work, so no point in rendering it
  if (!fields || !sitecoreContext.goFundMeScriptUrl) {
    return <MissingDataSource />;
  }

  if (isExperienceEditor) {
    return (
      <div data-component="authorable/form/gofundmeform">
        <div className={classnames('flex', 'pb-3', 'rte')}>
          <span>Form Id:</span>
          <RichTextA11yWrapper
            className={classnames('mx-2', 'rte')}
            field={fields.formId}
            editable
          />
        </div>
        <div className={classnames('flex', 'pb-3', 'rte')}>
          <span>Campaign Number (classy):</span>
          <RichTextA11yWrapper
            className={classnames('mx-2', 'rte')}
            field={fields.campaignNumber as unknown as Field<string>}
            editable
          />
        </div>
      </div>
    );
  }

  const id = fields.formId.value;
  const campaignNumber = fields.campaignNumber.value;

  return (
    <>
      <div data-component="authorable/form/gofundmeform">
        <div className={classnames('max-w-[440px]', 'm-auto')}>
          <div id={id} {...{ classy: campaignNumber }} />
        </div>
      </div>
    </>
  );
};

export default GoFundMeForm;
